import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { keycloak } from "..";
import { APP_API } from "../constants/constants";

export const appServiceApi = createApi({
  reducerPath: "appServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: APP_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }

        headers.set("ngrok-skip-browser-warning", "true");

        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    // if (
    //   result.error &&
    //   result.error?.status === 401 &&
    //   (result?.error?.data as any)?.message === "Unauthorized"
    // ) {
    //   // localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    //   window.location.reload();
    // }

    //  result.error?.status === 401 &&
    // (result?.error?.data as any)?.message === "Authorization token missing"
    if (
      result.error &&
      result.error?.status === 401 &&
      (result?.error?.data as any)?.message ===
        "OTP verification failed: OTP Expired"
    ) {
      return result;
    }

    const errorData = (result?.error?.data as any) || {};
    const errorCode =
      errorData?.code ||
      errorData?.data?.code ||
      (typeof errorData?.message === "object" ? errorData?.message?.code : "");
    const isDeactivated = errorCode === "ACCOUNT_DEACTIVATED";

    if (result.error && result.error?.status === 401 && isDeactivated) {
      if (window.location.pathname !== "/admin/account-deactivated") {
        window.location.assign("/admin/account-deactivated");
      }
      return result;
    }

    if (
      result.error &&
      result.error?.status === 401
      // (result?.error?.data as any)?.message === "Authorization token missing"
    ) {
      try {
        await keycloak.logout();
        localStorage.clear();
      } catch (err) {
        console.error("Keycloak logout failed:", err);
      }
    }

    return result;
  },
  tagTypes: [
    "GetAllCompany",
    "GetSingleCompany",
    "GetUser",
    "GetUsers",
    "GetSingleUser",
    "GetAllVendorBatch",
    "GetVendorPayment",
    "GetDisbursmentPayment",
    "GetBalanceCheck",
    "GetAllDisbursementBatch",
    "GetVendorAmount",
    "GetSalaryAmount",
    "CheckVendorDisbursement",
    "CheckSalaryDisbursement",
    "GetAllProduct",
    "UserProduct",
    "GetAllRole",
    "GetUsersByProjectRole",
    "GetProjectsByUser",
    "GetAllWorkFlow",
    "GetAllBatch",
    "GetSingleBatch",
    "GetBatchLog",
    "GetUserPerformBatch",
    "GetUserPoolProject",
    "GetSingleWorkFlow",
    "GetAllBatchVendor",
    "GetAllVendorsPayment",
    "GetAllBatchPendingList",
    "GetDashboardData",
    "CheckUserBelongProject",
    "GetUserLogData",
    "UserCompanyCount",
    "GetAllStatements",
    "GetDownloadStatements",
    "GetBankStatementsDownload",
    "GetAllAssignProject",
    "GetAllProtalDepartment",
    "GetSingleProtalDepartment",
    "GetAllProtalSubDepartment",
    "GetSingleProtalSubDepartment",
    "GetPortalSingleSubDepartmentById",
    "GetUserStatus",
    "OtpRequestTime",
    "GetAllDisbursementType",
    "GetDepartments",
    "GetDepartmentDetails",
    "GetDesignations",
    "GetDesignationDetails",
    "GetWorkStations",
    "GetWorkStationDetails",
    "GetExpenseUnits",
    "GetExpenseUnitDetails",
    "GetEmployees",
    "GetEmployeeDetails",
    "GetEmployeeAdditionalFields",
    "GetEmployeeAdditionalFieldDetails",
    "GetBusinessData",
    "GetGrade",
    "GetEmployeeBreakdownSalaryDetails",
    "GetAdditionDeductionSalary",
    "GetVariableSalary",
    "GetReport",
    "GetPayrollSetting",
    "GetPayComponentSetting",
    "GetApprovalMatrix",
    "GetApprovalMatrixDetails",
    "GetRoles",
    "GetUserList",
    "GetCompanyWallet",
    "GetAllWalletTag",
    "GetSingleWalletTag",
    "GetAllWallet",
    "GetSingleWallet",
    "GetUserWalletRoleById",
    "GetUserWalletRoleByUserId",
    "GetUsersWithDisbursementAccess",
    "GetUserPoolByWalletId",
    "GetSingleUserWalletRole",
    "GetAllPermission",
    "GetPermissionDetails",
    "GetAllUserPermissionId",
    "GetAllGroupByUserId",
    "GetLogByUserId",
  ],
  keepUnusedDataFor: 0,

  endpoints: () => ({}),
});
